import styled from 'styled-components';
import type { TenderVat } from '@shared/api';
import { fmtMoney } from '@shared/lib/smetaLabels';
import { totalNoteText } from './tenderTotals';

const Note = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.muted};
`;

/** Строка под итогом расчёта по тендеру (внутри `PriceLevelSummary`): итог —
 *  без НДС и прочих затрат, НДС на дату расчёта — отдельно, в итог не входит. */
export function TenderTotalNote({ vat }: { vat: TenderVat | null | undefined }) {
  return <Note>{totalNoteText(vat ?? null, fmtMoney)}</Note>;
}
